export const getTrueKey = <T extends string>(
    object: Partial<Record<T, boolean>>,
) => Object.entries(object).find(([, value]) => value)?.[0] as T | undefined;
